import { render, staticRenderFns } from "./ReportWorkerHourAndTag.vue?vue&type=template&id=32037918&scoped=true"
import script from "./ReportWorkerHourAndTag.vue?vue&type=script&lang=js"
export * from "./ReportWorkerHourAndTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32037918",
  null
  
)

export default component.exports